export default __webpack_public_path__ + "static/media/aadhaar-placeholder.a0a02176.png";